export default defineNuxtPlugin(() => {
  const loader = new OnDemand('/scripts/hubspot-x-jquery.js')
  loader.load()
})
